import { Dimmer, Loader, Segment } from "semantic-ui-react";
import "./Loading.css";

export const Loading = () => {
    return (
        <Segment id="basic-loading" basic>
            <Dimmer id="dimmer-loading" active inverted>
                <Loader id="loader-loading" inverted size="huge">
                    Loading...
                </Loader>
            </Dimmer>
        </Segment>
    );
};
